var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHistory = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.14286 0C5.35619 0 2.28571 3.13444 2.28571 7H0L2.96381 10.0256L3.01714 10.1344L6.09524 7H3.80952C3.80952 3.99 6.19429 1.55556 9.14286 1.55556C12.0914 1.55556 14.4762 3.99 14.4762 7C14.4762 10.01 12.0914 12.4444 9.14286 12.4444C7.67238 12.4444 6.33905 11.83 5.37905 10.8422L4.29714 11.9467C5.53905 13.2144 7.24571 14 9.14286 14C12.9295 14 16 10.8656 16 7C16 3.13444 12.9295 0 9.14286 0ZM8.38095 3.88889V7.77778L11.6419 9.75333L12.1905 8.81222L9.52381 7.19444V3.88889H8.38095Z",
  fill: "white"
})));
export { SvgHistory as ReactComponent };
export default __webpack_public_path__ + "assets/icons/history.9a9a41.svg";